let reg_upper = /(^[a-z_])+([a-z0-9_])*$/g;

const dbKeyWords = {
  TRIGGER: 1,
  RANK: 1,
  WHERE: 1,
  REVOKE: 1,
  THEN: 1,
  CONNECT: 1,
  GRANT: 1,
  HAVING: 1,
  NULL: 1,
  ALL: 1,
  INDEX: 1,
  SMALLINT: 1,
  RENAME: 1,
  EXCLUSIVE: 1,
  BETWEEN: 1,
  SHARE: 1,
  MODE: 1,
  UNION: 1,
  SET: 1,
  START: 1,
  VALUES: 1,
  VIEW: 1,
  WITH: 1,
  CHAR: 1,
  FROM: 1,
  SELECT: 1,
  BY: 1,
  OR: 1,
  ELSE: 1,
  CHECK: 1,
  VARCHAR2: 1,
  CREATE: 1,
  AS: 1,
  TABLE: 1,
  LONG: 1,
  ASC: 1,
  DESC: 1,
  CLUSTER: 1,
  FLOAT: 1,
  NOT: 1,
  DELETE: 1,
  ALTER: 1,
  IDENTIFIED: 1,
  INTEGER: 1,
  SIZE: 1,
  NOWAIT: 1,
  ANY: 1,
  FOR: 1,
  INTERSECT: 1,
  SYNONYM: 1,
  PCTFREE: 1,
  UPDATE: 1,
  DEFAULT: 1,
  UNIQUE: 1,
  PRIOR: 1,
  RESOURCE: 1,
  DATE: 1,
  RAW: 1,
  OPTION: 1,
  OF: 1,
  DECIMAL: 1,
  PUBLIC: 1,
  TO: 1,
  INSERT: 1,
  DROP: 1,
  COMPRESS: 1,
  LIKE: 1,
  NOCOMPRESS: 1,
  IS: 1,
  ON: 1,
  EXISTS: 1,
  DISTINCT: 1,
  LOCK: 1,
  AND: 1,
  GROUP: 1,
  VARCHAR: 1,
  IN: 1,
  INTO: 1,
  NUMBER: 1,
  ORDER: 1,
  MINUS: 1
};

function isFreezeMeatData(metadata) {
  if (metadata.isFromMetaData || metadata.isuser) {
    return true;
  }
  return false;
}

function createMetadataLabel(com) {
  let label = "";
  let remark = com.metadata.remark;
  if (com.label) {
    if (remark) {
      label = remark.replace(/\{label\}/g, com.label);
    } else {
      label = com.label;
    }
  }
  return label;
}

function getDesignOption(com) {
  return com?.$options?.design || {};
}

function getDesignMetaDataOption(com) {
  return getDesignOption(com)?.metadata || {};
}

function getMetaDataPrefixById(id) {
  let arr = id.split(".");
  arr = arr.slice(0, arr.length - 1);
  return arr.join("_");
}

//创建页面元数据
function createViewMetaData(page, mobile, callback) {
  let ns = [page.context.B, page.context.M];
  let fullns = [page.context.B, page.context.M, page.name];
  // let path = fullns.replace(/\./g, "/");
  let md = {
    path: fullns.join("/"),
    nameSpace: fullns.join("."),
    accessRole: page.dataAccessRole || [],
    isForm: page.pageType == "form" || page.pageType == "question" ? true : false,
    needLogin: page.needLogin,
    pageState: page.pageType,
    mode: page.mode || enums.viewMode.DEVELOP,
    xssConfig: page.xssConfig,
    init: { privilege: page.pagePrivilege || [] },
    query: {},
    export: {},
    browseScope: {},
    metadata: {},
    isMobile: mobile,
    attach: {},
    isEs: page.isEs || false,
    esIndexName: page.isEs ? page.esIndexName || null : undefined
  };
    //大屏页面添加密级别功能
  if (page.isDataViewControl) {
    let { confidentialityLevel, confidentialityLevelText, releaseSecretTime } = page.getConfidentiality()
    md.security_level_text = confidentialityLevelText
    md.security_level_value = confidentialityLevel
    md.security_level_expirydate = releaseSecretTime
  }
  
  let result = createComponentMetaData(page, page, callback);
  let orderNum = 0;
  _.each(result, (item) => {
    if (item.schema) {
      let schema = item.schema;
      let list = dsf.type(schema) != "array" ? [schema] : schema;
      _.each(list, (el) => {
        if (el.metadata) {
          md.metadata[el.key] = dsf.mix({}, el.metadata);
          md.metadata[el.key].order = ++orderNum;
          md.metadata[el.key].ref = el.self;
          delete el.metadata.content;
        }
        if (el.query) {
          md.query = el.query;
        }
        if (el.browseScope) {
          md.browseScope = el.browseScope;
        }
        if (el.export) {
          md.export = dsf.mix(md.export, el.export);
        }
        if (el.attach) {
          let attach = dsf.mix(true, {}, el.attach);
          dsf.mix(true, md.attach, attach);
        }
        let self = el?.self || el?._self || null;
        if (self) {
          let designOptions = self?.$options?.design || {};
          let metadataNode = designOptions?.metadata || {};
          metadataNode.created && metadataNode.created.call(self, el, md);
        }
      });
    }
  });

  _.forOwn(md.metadata, (it, key) => {
    //为设置过拼音的字段创建拼音元数据
    let vattrs = it?.valueAttributes || [];
    let pyfiels = _.filter(vattrs || [], (it) => {
      return it.pinyin;
    });
    _.each(pyfiels, (va) => {
      let qpkey = "pinyin_" + it.code + (vattrs.length > 1 ? "_" + va.code : ""); //va.pinyinFieldName;
      let jpkey = "py_" + it.code + (vattrs.length > 1 ? "_" + va.code : "");
      let qpmeta = null;
      let jpmeta = null;
      let qpmkey, jpmkey;
      if (!md.metadata[qpkey]) {
        qpmeta = dsf.mix(true, {}, it);
        qpmeta.content = "{}";
        qpmeta.name = (it.name || it.code) + "_全拼";
        qpmeta.cname = (it.cname || it.code) + "_全拼";
        qpmeta.ckey = "text-meta-data";
        qpmeta.code = qpkey;
        qpmeta.id = it.at + "." + qpmeta.code;
        qpmeta.required = false;
        qpmeta.validate = null;
        qpmeta.pinyinField = true;
        qpmeta.order = ++orderNum;
        qpmeta.targetField = it.valueAttributes.length > 1 ? key + "_" + va.code : key;
        qpmeta.currentControl = {
          text: "文本框",
          value: mobile ? "dsf.mobile.textbox" : "dsf.textbox"
        };
        qpmeta.controls = [qpmeta.currentControl];
        qpmeta.valueAttributes = [
          {
            code: "text",
            defaultValue: "@[pinyin('" + qpmeta.targetField + "')]",
            emptyValidate: false,
            encrypt: false,
            length: va.length,
            name: "文本",
            pinyin: false,
            type: { text: "文本", value: "string" },
            unit: null
          }
        ];
        let mkey = qpmeta.at.replace(".", "_") + "." + qpmeta.code;
        qpmeta.dataKey = mkey;
      }
      if (!md.metadata[jpkey]) {
        jpmeta = dsf.mix(true, {}, it);
        jpmeta.content = "{}";
        jpmeta.name = (it.name || it.code) + "_简拼";
        jpmeta.cname = (it.cname || it.code) + "_简拼";
        jpmeta.ckey = "text-meta-data";
        jpmeta.code = jpkey;
        jpmeta.id = it.at + "." + jpmeta.code;
        jpmeta.required = false;
        jpmeta.validate = null;
        jpmeta.pinyinField = true;
        jpmeta.order = ++orderNum;
        jpmeta.targetField = it.valueAttributes.length > 1 ? key + "_" + va.code : key;
        jpmeta.currentControl = {
          text: "文本框",
          value: mobile ? "dsf.mobile.textbox" : "dsf.textbox"
        };
        jpmeta.controls = [jpmeta.currentControl];
        jpmeta.valueAttributes = [
          {
            code: "text",
            defaultValue: "@[py('" + qpmeta.targetField + "')]",
            emptyValidate: false,
            encrypt: false,
            length: va.length,
            name: "文本",
            pinyin: false,
            type: { text: "文本", value: "string" },
            unit: null
          }
        ];
        let mkey = jpmeta.at.replace(".", "_") + "." + jpmeta.code;
        jpmeta.dataKey = mkey;
      }
      if (qpmeta) {
        md.metadata[qpmeta.dataKey] = qpmeta;
      }
      if (jpmeta) {
        md.metadata[jpmeta.dataKey] = jpmeta;
      }
    });

    //枚举选项创建每个枚举单独冗余字段
    if (it.disperseFields) {
      let com = it.ref;
      it.itemFields = [];
      if (com) {
        com.metadata.itemFields = [];
        let items = [];
        dsf.deepForEach(com?.items || [], (item) => {
          if (!item.children || !item.children.length) {
            items.push(item);
          }
        });
        _.each(items, (item, i) => {
          let index = i + 1;
          let itemmeta = dsf.metadata.get("text-meta-data");
          itemmeta.content = "{}";
          itemmeta.currentControl = { text: "文本框", value: mobile ? "dsf.mobile.textbox" : "dsf.textbox" };
          itemmeta.controls = [itemmeta.currentControl];
          itemmeta.name = (it.name || it.code) + "_选项_" + index;
          itemmeta.cname = (it.cname || it.code) + "_item_" + index;
          // itemmeta.ckey = "text-meta-data";
          itemmeta.code = it.code + "_item_" + index;
          itemmeta.id = it.at + "." + itemmeta.code;
          itemmeta.at = it.at;
          itemmeta.order = ++orderNum;
          itemmeta.targetField = key;
          itemmeta.level = it.level;
          itemmeta.itemValue = item[com?.valueField || "value"];
          let value_valueAttribute = _.find(it.valueAttributes, (it) => it.code == "value");
          if (value_valueAttribute) {
            itemmeta.valueAttributes[0].length = value_valueAttribute.length;
            itemmeta.type = value_valueAttribute.type;
          }
          let mkey = itemmeta.at.replace(".", "_") + "." + itemmeta.code;
          itemmeta.dataKey = mkey;
          md.metadata[mkey] = itemmeta;
          let info = {
            key: mkey,
            itemValue: itemmeta.itemValue
          };
          com.metadata.itemFields.push(info);
          it.itemFields.push(info);
        });
      }
    }
  });
  //替换元数据中name字符中的二元运算符,逗号,数据处理里遇见
  _.forOwn(md.metadata, (it, key) => {
    it.name = (it.name || "").replace(/\-/g, "_").replace(/\+/g, "").replace(/\*/g, "").replace(/\//g, "").replace(/\,/g, "");
  });

  let mainTable = [];
  let subTable = [];
  if (page.pageType == "form") {
    _.each(md.metadata, (it) => {
      if (it.level == 1) {
        subTable.push(it);
      } else if (it.level == 0) {
        mainTable.push(it);
      }
    });
    //修改表单中只有子表无法保存的情况，验证当表单中只有子表的时候,强制加入一个修改时间作为主表
    if (mainTable.length == 0 && subTable.length > 0) {
      let updateTime = dsf.metadata.get("system-meta-data", {
        id: ns.join(".") + ".ds_update_time",
        at: ns.join("."),
        controls: [{ text: "修改时间", value: "dsf.updatetime" }],
        currentControl: { text: "修改时间", value: "dsf.updatetime" },
        code: dsf.config.kw.updatetime,
        content: "{}",
        inSubTable: "",
        dataKey: ns.join("_") + ".ds_update_time",
        level: 0,
        valueAttributes: [
          {
            name: "修改时间",
            code: dsf.config.kw.updatetime,
            type: dsf.metadata.getDataType("date"),
            length: "",
            defaultValue: null,
            unit: null
          }
        ]
      });
      updateTime.order = subTable.length + 1;
      md.metadata[updateTime.dataKey] = updateTime;
      // md.metadata.unshift(updateTime);
      // _.each(md.metadata, (it, i) => {
      //   it.order = i + 1;
      // })
    }
  }

  return md;
}

//修复元数据中controls,currentControl中的值没有dsf.开头
function checkMetadataControlValue(metadata) {
  if (metadata.currentControl && metadata.currentControl.value) {
    if (!metadata.currentControl.value.startsWith("dsf.")) {
      metadata.currentControl.value = "dsf." + metadata.currentControl.value;
    }
  }
  _.each(metadata.controls, (ctrl) => {
    if (!ctrl.value.startsWith("dsf.")) {
      ctrl.value = "dsf." + ctrl.value;
    }
  });
}

//创建组件元数据
function createComponentMetaData(component, root, callback, noCheck) {
  let arr = [];
  dsf.designer.recursionLayoutTree(component, null, null, (el) => {
    let designOptions = el.$options.design || {};
    let metadataNode = designOptions.metadata || {};
    let result = metadataNode.create && metadataNode.create.call(el, root);
    if (result) {
      arr.push({
        component: el,
        schema: result
      });
    }
    let isDeep = dsf.isDef(metadataNode.isDeep) ? metadataNode.isDeep : true;
    return isDeep;
  });
  let ns_arr = [root.context.B, ...root.context.M.split(/\.|\//)];
  let key = ns_arr.join("_").replace(/\./g, "_");
  for (let i = 0; i < arr.length; i++) {
    let com = arr[i].component;
    let result = arr[i].schema;
    //如果当前组件是子表或者列表
    if (com.childMetaDataCodes) {
      //子表
      if (com.isFormControl) {
        subTableMetadataHandler(com, result, ns_arr);
      }
      //列表
      else {
        datagridMetadataHandler(com, result, ns_arr);
      }
    } else {
      //表单组件、树组件元数据处理
      result = dsf.type(result) == "array" ? result : [result];
      _.each(result, (el) => {
        let ctrl = el.self;
        if (el.metadata) {
          delete el.metadata.inColumnSlot;
          //表单组件元数据处理
          if (ctrl.isFormControl) {
            formItemMetadataHandler(ctrl, el, ns_arr);
          }
          //树组件元数据处理
          else if (el.metadata.ckey == "nav-tree-meta-data") {
            treeMetadataHandler(ctrl, el, ns_arr);
          } else {
            otherMetadataHandler(ctrl, el, ns_arr);
          }
        }
      });
    }
  }
  return arr;
}

function validateCaption(el) {
  let errors = [];
  let ctrlTypeArr = el.$props.ctrlType.split(".");
  let name = ctrlTypeArr[ctrlTypeArr.length - 1];
  if (el.$props.caption.startsWith(name)) {
    errors.push(el.$props.caption + "组件标识是无意义的，请修改");
  }
  reg_upper.lastIndex = 0;
  if (!reg_upper.test(el.$props.caption)) {
    if (el.$props.metadata && el.$props.metadata.$isValidate !== false) {
      errors.push(el.$props.caption + "组件标识必须是小写字母和数字");
    }
  }
  if (el.$props.metadata) {
    let fields = [];
    if (el.$props.metadata.valueAttributes.length > 1) {
      _.each(el.$props.metadata.valueAttributes, (it) => {
        let field = `${el.$props.caption}_${it.code}`;
        fields.push(field);
      });
    } else {
      fields.push(el.$props.caption);
    }
    _.each(fields, (it) => {
      if (dbKeyWords[it.toUpperCase()] === 1) {
        errors.push(it + "为特殊关键字不可使用");
      }
    });
  }

  return errors;
}

//创建拼音字段
function createPinyinField(metadata, fullKey) {
  // let vattrs = metadata?.valueAttributes || [];
  // let pyfiels = _.filter(vattrs || [], (it) => {
  //   return it.pinyin;
  // });
  // _.each(vattrs, (it) => {
  //   delete it.pinyinFieldName;
  //   delete it.pyFieldName;
  // });
  // if (pyfiels.length > 0) {
  //   _.each(pyfiels, (it) => {
  //     let at = metadata.at.replace(/\./g, "_");
  //     let qpkey = at + "." + "pinyin_" + metadata.code + (vattrs.length > 1 ? "_" + it.code : "");
  //     let jpkey = at + "." + "py_" + metadata.code + (vattrs.length > 1 ? "_" + it.code : "");
  //     it.pinyinFieldName = qpkey;
  //     it.pyFieldName = jpkey;
  //   });
  // }
}

//创建枚举类选项的冗余字段
function createEnumItemField(metadata, fullKey, items) {
  // if (metadata.disperseFields) {
  //   metadata.itemFields = [];
  //   _.each(items, (it, i) => {
  //     metadata.items.push(it);
  //     // metadata.itemFields.push(metadata.at + "." + metadata.code + "_item_" + i);
  //     // let m = dsf.metadata.get("text-meta-data");
  //     // let comType = {
  //     //   text: "文本框",
  //     //   value: "dsf.textbox"
  //     // };
  //     // m.controls.push(comType);
  //     // m.currentControl = comType;
  //     // m.at = metadata.at;
  //     // m.id = metadata.id + "_item_" + i;
  //     // m.code = metadata.code + "_item_" + i;
  //     // m.cname = metadata.cname + "_item_" + i;
  //     // m.name = metadata.name + "_选项_" + i;
  //   });
  // }
}

function setCtrlMetadataFullCode(ctrl, code) {
  if (ctrl?.$virtual) {
    ctrl.__layoutTree__.componentProps.metadata_fullcode = code;
  } else {
    ctrl.metadata_fullcode = code;
  }
}

//列表元数据处理
function datagridMetadataHandler(com, result, ns_arr) {
  dsf.array.removeAll(com.childMetaDataCodes);
  let key = ns_arr.join("_").replace(/\./g, "_");
  _.each(result, (el, i) => {
    let ctrl = el.self;
    if (el.metadata) {
      if (ctrl.isFormControl) {
        checkMetadataControlValue(el.metadata);
        /*isFromMetaData表示是由左侧元数据组拖动拖来的
          isuser表示是在表单保存时产生不同源时用户选择的
          以上两者元数据的key不会重新计算*/
        if (!isFreezeMeatData(el.metadata)) {
          el.metadata.cname = ctrl.caption;
          el.metadata.code = ctrl.caption;
          el.metadata.id = ns_arr.join(".") + "." + ctrl.caption;
          el.metadata.at = ns_arr.join(".");
          let label = createMetadataLabel(ctrl);
          el.metadata.name = label;
          el.metadata.level = 0;
          el.metadata.required = ctrl.required;
          el.key = key + "." + ctrl.caption;
          el.metadata.inSubTable = "";
          el.metadata.attachAttrs = ctrl.metadataAttach ? dsf.mix(true, {}, ctrl.metadataAttach) : void 0;
          el.metadata.dataKey = el.key;
          // ctrl?.$designer?.comonentMetadataHandler?.(ctrl, el.metadata);
          createPinyinField(el.metadata, el.key);
          setCtrlMetadataFullCode(ctrl, el.key);
        } else {
          let code_arr = el.metadata.id.split(".");
          let prefix = code_arr.slice(0, code_arr.length - 1);
          prefix = _.map(prefix, (it) => {
            return it.replace(/_/g, ".");
          });
          prefix = prefix.join(".").split(".");
          el.metadata.id = prefix.join(".") + "." + ctrl.caption;
          el.metadata.at = prefix.join(".");
          el.metadata.level = 0;
          let label = createMetadataLabel(ctrl);
          el.metadata.name = label || el.metadata.name;
          el.metadata.inSubTable = "";
          el.metadata.ctrlCaption = ctrl.caption;
          el.metadata.required = ctrl.required;
          el.metadata.attachAttrs = ctrl.metadataAttach ? dsf.mix(true, {}, ctrl.metadataAttach) : void 0;
          let fullCode = prefix.join("_") + "." + ctrl.caption;
          el.key = fullCode;
          el.metadata.dataKey = el.key;
          // ctrl?.$designer?.comonentMetadataHandler?.(ctrl, el.metadata);
          createPinyinField(el.metadata, el.key);
          setCtrlMetadataFullCode(ctrl, el.key);
        }
        dsf.array.ensure(com.childMetaDataCodes, el.key);
      }
    }
  });
}
//子表元数据处理
function subTableMetadataHandler(com, result, ns_arr) {
  let metadataOptions = getDesignMetaDataOption(com);
  dsf.array.removeAll(com.childMetaDataCodes);
  let key = ns_arr.join("_").replace(/\./g, "_");
  let existFromMeta = [];
  let subMetaDataKey = "";
  // let sameSource = metadataOptions?.sameSource || false;
  let sourceKey = [];
  _.each(result, (el) => {
    if (el.metadata && (el.metadata.isFromMetaData || el.metadata.isuser)) {
      if (!el?.self?.isOneToMany) {
        existFromMeta.push(el.metadata);
        let key = getMetaDataPrefixById(el.metadata.id);
        dsf.array.ensure(sourceKey, key);
      }
    }
  });

  //对子表元数据结果的处理，如果子表组件存在自己的元数据处理函数则使用自己的，否则使用默认的
  if (!metadataOptions.reaultHandler) {
    if (sourceKey.length > 1) {
      //先查看子表内部是否存在不同的元数据
      throw `${com.label || com.caption}中不能存在不同源的元数据`;
    }
    // let isChangeTableName = false;
    let subTableDefaultNameArr = null;
    //循环子表生成的元数据结构（类型为数组，包含子表中的子组件。且子表本身元数据对象排在数组第一个）
    _.each(result, (el, i) => {
      let ctrl = el.self;
      let currMetaDataKey = "";
      if (i == 0) {
        let code = ctrl.caption;
        subTableDefaultNameArr = [...ns_arr, ctrl.caption];
        let tableNameArr = subTableDefaultNameArr;
        let id = tableNameArr.join(".");
        let at = tableNameArr.join(".");
        let name = ctrl.label; //ctrl.metadata.name || ctrl.label;
        let fullCode = tableNameArr.join("_");
        currMetaDataKey = subMetaDataKey = tableNameArr.join("_");
        if (existFromMeta.length > 0) {
          //如果子表中存在不同源的元数据，强制以已有元数据为主（强制同源）
          let code_arr = existFromMeta[0].at.split(".");
          code = code_arr[code_arr.length - 1];
          id = code_arr.join(".");
          at = code_arr.join(".");
          name = ctrl.label;
          fullCode = code_arr.join("_");
          currMetaDataKey = subMetaDataKey = code_arr.join("_");
        }
        checkMetadataControlValue(el.metadata);
        el.metadata.code = code;
        el.metadata.id = id;
        el.metadata.at = at;
        el.metadata.name = name;
        el.metadata.cname = ctrl.caption;
        el.metadata.required = ctrl.required;
        el.metadata.attachAttrs = ctrl.metadataAttach ? dsf.mix(true, {}, ctrl.metadataAttach) : void 0;
        el.key = el.metadata.dataKey = fullCode;
        // ctrl?.$designer?.comonentMetadataHandler?.(ctrl, el.metadata);
        createPinyinField(el.metadata, el.key);
        setCtrlMetadataFullCode(ctrl, fullCode);
        if (ctrl.totalRowFieldKey) {
          //为子表元数据写入合计行判断的字段信息
          el.metadata.totalRowFieldKey = fullCode + "." + ctrl.totalRowFieldKey;
          el.metadata.totalRowFieldTrueValue = ctrl.totalRowFieldTrueValue;
        }
      } else {
        if (el.metadata) {
          checkMetadataControlValue(el.metadata);
          el.metadata.inSubTable = subMetaDataKey;
          if (ctrl) {
            el.metadata.code = ctrl.caption;
            el.metadata.cname = ctrl.caption;
            el.metadata.id = subMetaDataKey.replace(/\_/g, ".") + "." + ctrl.caption;
            el.metadata.at = subMetaDataKey.replace(/\_/g, ".");
            let label = createMetadataLabel(ctrl);
            el.metadata.name = label || ctrl.metadata.name;
            el.metadata.required = ctrl.required;
            el.metadata.attachAttrs = ctrl.metadataAttach ? dsf.mix(true, {}, ctrl.metadataAttach) : void 0;
            currMetaDataKey = subMetaDataKey + "." + ctrl.caption;
            el.key = el.metadata.dataKey = currMetaDataKey;
            // ctrl?.$designer?.comonentMetadataHandler?.(ctrl, el.metadata);
            createPinyinField(el.metadata, el.key);
            setCtrlMetadataFullCode(ctrl, currMetaDataKey);
          } else {
            currMetaDataKey = subMetaDataKey + "." + el.metadata.code;
          }
        }
      }
      el.metadata.level = 1;
      el.metadata.content = ctrl?.metadata?.content || "{}";
      el.key = currMetaDataKey;
    });
  } else {
    metadataOptions.reaultHandler(com, result, ns_arr);
  }
  _.each(result, (el, i) => {
    if (el.metadata.at !== el.metadata.id) {
      let metadataOptions = getDesignMetaDataOption(com);
      dsf.array.ensure(com.childMetaDataCodes, el.key);
    }
  });
}
//表单项元数据处理
function formItemMetadataHandler(com, result, ns_arr) {
  let key = ns_arr.join("_").replace(/\./g, "_");
  let el = result;
  checkMetadataControlValue(el.metadata);
  /*isFromMetaData表示是由左侧元数据组拖动拖来的
  isuser表示是在表单保存时产生不同源时用户选择的
  以上两者元数据的key不会重新计算*/
  if (!isFreezeMeatData(el.metadata)) {
    let prefix = ns_arr;
    el.metadata.cname = com.caption;
    el.metadata.code = com.caption;
    el.metadata.id = `${prefix.join(".")}.${com.caption}`;
    el.metadata.at = prefix.join(".");
    let label = createMetadataLabel(com);
    el.metadata.name = label || com.metadata.name;
    el.metadata.level = 0;
    el.metadata.inSubTable = "";
    el.metadata.required = com.required;
    el.metadata.attachAttrs = com.metadataAttach ? dsf.mix(true, {}, com.metadataAttach) : void 0;
    let fullCode = prefix.join("_") + "." + com.caption;
    el.metadata.dataKey = fullCode;
    el.key = fullCode;
    // ctrl?.$designer?.comonentMetadataHandler?.(com, el.metadata);
    setCtrlMetadataFullCode(com, fullCode);
    createPinyinField(el.metadata, el.key);
    createEnumItemField(el.metadata, el.key, com.items);
  } else {
    let code_arr = el.metadata.id.split(".");
    let prefix = code_arr.slice(0, code_arr.length - 1);
    prefix = _.map(prefix, (it) => {
      return it.replace(/_/g, ".");
    });
    prefix = prefix.join(".").split(".");
    el.metadata.id = prefix.join(".") + "." + com.caption;
    el.metadata.at = prefix.join(".");
    el.metadata.ctrlCaption = com.caption;
    el.metadata.level = 0;
    let label = createMetadataLabel(com);
    el.metadata.name = label || com.metadata.name;
    el.metadata.inSubTable = "";
    el.metadata.required = com.required;
    el.metadata.attachAttrs = com.metadataAttach ? dsf.mix(true, {}, com.metadataAttach) : void 0;
    let fullCode = prefix.join("_") + "." + com.caption;
    el.key = fullCode;
    el.metadata.dataKey = fullCode;
    createPinyinField(el.metadata, el.key);
    createEnumItemField(el.metadata, el.key, com.disperseFields ? com.items : []);
    setCtrlMetadataFullCode(com, fullCode);
  }
  el.metadata.content = com.metadata.content || "{}";
}
//树元数据
function treeMetadataHandler(com, result, ns_arr) {
  let key = ns_arr.join("_").replace(/\./g, "_");
  let el = result;
  let caption = com.caption;
  // el.ref = ctrl;
  el.metadata.cname = caption;
  el.metadata.code = caption;
  let label = createMetadataLabel(com);
  el.metadata.name = label || com.metadata.name;
  el.metadata.level = 0;
  el.metadata.content = com.metadata.content || "{}";
  if (com.async && com.asyncDataSource * 1 == 2 && com.asyncChooseMetaData.code && com.asyncChooseMetaData.code.id) {
    el.metadata.id = com.asyncChooseMetaData.code.at + "." + caption;
    el.metadata.at = com.asyncChooseMetaData.code.at;
    key = com.asyncChooseMetaData.code.at.split(".").join("_");
  } else {
    let _k = key;
    el.metadata.id = _k.replace(/\_/g, ".") + "." + caption;
    el.metadata.at = _k.replace(/\_/g, ".");
  }
  key += "." + caption;
  el.metadata.dataKey = key;
  el.metadata.attachAttrs = com.metadataAttach ? dsf.mix(true, {}, com.metadataAttach) : void 0;
  el.key = key;
  // com?.$designer?.comonentMetadataHandler?.(com, el.metadata);
  setCtrlMetadataFullCode(com, key);
  createPinyinField(el.metadata, el.key);
}
//其他携带元数据的组件
function otherMetadataHandler(com, result, ns_arr) {
  let key = ns_arr.join("_").replace(/\./g, "_");
  let el = result;
  checkMetadataControlValue(el.metadata);
  //其他可能带有元数据的组件
  el.metadata.cname = com.caption;
  el.metadata.code = com.caption;
  el.metadata.id = ns_arr.join(".") + "." + com.caption;
  el.metadata.at = ns_arr.join(".");
  let label = createMetadataLabel(com);
  el.metadata.name = label || com.metadata.name;
  el.metadata.level = 0;
  el.metadata.content = com.metadata.content || "{}";
  el.metadata.required = com.required;
  el.metadata.attachAttrs = com.metadataAttach ? dsf.mix(true, {}, com.metadataAttach) : void 0;
  el.key = key + "." + com.caption;
  // com?.$designer?.comonentMetadataHandler?.(com, el.metadata);
  setCtrlMetadataFullCode(com, key);
  createPinyinField(el.metadata, el.key);
}

export { dbKeyWords, isFreezeMeatData, checkMetadataControlValue, createViewMetaData, createComponentMetaData, validateCaption, createPinyinField, setCtrlMetadataFullCode };
